import { AsyncPipe, DecimalPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { OnlyNumberDirective, SdvorButtonComponent, SwitchComponent } from '@sdvor/shared/ui';
import { BonusWidgetComponent } from '@sdvor/shared/ui/v2';
import { IconModule } from '@spartacus/storefront';
import { SdvorSubmitOrderModule } from '../submit-order';
import { SdvorCheckoutBonusComponent } from './checkout-bonus/checkout-bonus.component';
import { SdvorCheckoutOrderSummaryComponent } from './checkout-order-summary.component';

@NgModule({
  imports: [
    NgIf,
    AsyncPipe,
    DecimalPipe,
    RouterLink,
    ReactiveFormsModule,
    SdvorSubmitOrderModule,
    SwitchComponent,
    SdvorButtonComponent,
    IconModule,
    OnlyNumberDirective,
    BonusWidgetComponent,
  ],
  declarations: [SdvorCheckoutOrderSummaryComponent, SdvorCheckoutBonusComponent],
  exports: [SdvorCheckoutOrderSummaryComponent],
})
export class SdvorCheckoutOrderSummaryModule {}
